<ohp-feature-tooltip *ngFor="let tooltip of tooltips; trackBy: trackByIndex" [text]="tooltip.text" [selector]="tooltip.ref"></ohp-feature-tooltip>
